import React from "react";

export default function Forbidden() {
  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <h1>403 - Forbidden</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
}